<template>
    <div class="boolean-expression-widget">
        <header>
            <button type="button" v-if="!editMode" class="edit-btn" @click="enableEdit"><i class="fa fa-pencil"></i> edit</button>
            <template v-if="editMode">
                <button type="button" @click="cancelEdit" class="edit-btn edit-btn-cancel"><i class="fa fa-close"></i></button>
                <button type="button" @click="saveEdit" class="edit-btn edit-btn-save"><i class="fa fa-check"></i></button>
            </template>
        </header>
        <div class="body">
            <boolean-expression
                :expression="renderedExpression"
                :editMode="editMode"
                @editExpression="edit"
                @addExpression="add">
            </boolean-expression>
        </div>
        <boolean-expression-modal
            v-if="showModal"
            :expression="editAction == 'edit' ? editedExpression : null"
            @close="closeModal"
            @save="save">
        </boolean-expression-modal>
    </div>
</template>
<script>
 import BooleanExpression from 'components/elements/BooleanExpression';
 import BooleanExpressionModal from 'components/modals/BooleanExpressionModal';
 
 
 export default {
     name: 'boolean-expression-widget',
     components: {
         BooleanExpression,
         BooleanExpressionModal
     },
     props: {
         expression: {
             type: Object,
              default: null
         }
     },
     data () {
         return {
             editMode: false,
             showModal: false,
             renderedExpression: null,
             uneditedExpression: null,
             editedExpression: null,
             editAction: null
         }
     },
     watch: {
         expression() {
             this.renderedExpression = _.cloneDeep(this.expression);
         }
     },
     computed: {
     },
     created() {
         this.renderedExpression = _.cloneDeep(this.expression);
     },
     methods: {
         closeModal() {
             this.editedExpression = null;
             this.editAction = null;
             this.showModal = false;
         },
         enableEdit() {
             this.uneditedExpression = _.cloneDeep(this.renderedExpression);
             this.editMode = true;
         },
         edit(expression) {
             this.editedExpression = expression;
             this.editAction = 'edit';
             this.showModal = true;
         },
         add(expression) {
             this.editedExpression = expression;
             this.editAction = 'add';
             this.showModal = true;
         },
         cancelEdit() {
             if (window.confirm('No changes will be saved, are you sure?')) {
                 this.renderedExpression = this.uneditedExpression;
                 this.editMode = false;
             }
         },
         pruneDeleted(expression) {
             if (expression) {
                 if (expression.hasOwnProperty('deleted') && expression.deleted) {
                     return null;
                 }
                 else if (expression.hasOwnProperty('operands')) {
                     expression.operands = expression.operands
                                                     .map((x) => this.pruneDeleted(x))
                                                     .filter((x) => x);
                     if (!expression.operands.length) {
                         return null;
                     }
                 }
                 return expression;
             }
             return null;
         },
         saveEdit() {
             this.editMode = false;
             this.$emit('updateExpression', this.pruneDeleted(this.renderedExpression));
         },
         addExpression(addedExpression) {
             if (this.editedExpression == null) {
                 this.renderedExpression = _.cloneDeep(addedExpression);
             }
             else if (this.editedExpression.hasOwnProperty('operands')) {
                 this.editedExpression.operands.push(addedExpression);
             }
         },
         editExpression(updatedExpression) {
             if (updatedExpression == null) {
                 // delete
                 this.$set(this.editedExpression, 'deleted', true);
             }
             else {
                 // edit
                 let properties = Object.getOwnPropertyNames(updatedExpression);

                 for (let k of properties) {
                     this.editedExpression[k] = null;
                     this.$set(this.editedExpression, k, updatedExpression[k]);
                 }

                 for (let k of Object.getOwnPropertyNames(this.editedExpression)) {
                     if (properties.indexOf(k) == -1) {
                         delete this.editedExpression[k];
                     }
                 }
             }
         },
         save(updatedExpression) {
             if (this.editAction == 'add' && updatedExpression) {
                 this.addExpression(updatedExpression);
             }
             else if (this.editAction == 'edit') {
                 this.editExpression(updatedExpression);
             }
             this.closeModal();
         }
     }
 }
</script>
<style lang="scss">
 .boolean-expression-widget {
     display: flex;
     flex-direction: column;
     width: 100%;

     header {
         margin-bottom: .5rem;
     }

     .edit-btn {
         border: none;
         background: none;

         &.edit-btn-cancel {
             color: red;
         }

         &.edit-btn-save {
             color: green;
         }
     }
 }
 
</style>



// WEBPACK FOOTER //
// BooleanExpressionWidget.vue?223cb0a6